module.exports = __webpack_public_path__ + "static/media/2.3.ebc9888a.zip";